import { Navigate } from 'react-router-dom'
import PageTransition from '@/components/ui/PageTransition'
import Section from '@/components/layout/Section'
import ProjectNav from '@/components/ui/ProjectNav'
import VodafoneHero from '@/components/vodafone/VodafoneHero'
import VodafoneInteractionPatterns from '@/components/vodafone/VodafoneInteractionPatterns'
import VodafoneHandoff from '@/components/vodafone/VodafoneHandoff'
import VodafoneImpact from '@/components/vodafone/VodafoneImpact'
import { getProjectBySlug, getAdjacentProjects } from '@/data/projects'

export default function VodafonePage() {
  const project = getProjectBySlug('vodafone')

  if (!project) {
    return <Navigate to="/" replace />
  }

  const { prev, next } = getAdjacentProjects('vodafone')

  return (
    <PageTransition>
      <Section className="pt-8 md:pt-12">
        <VodafoneHero project={project} />
      </Section>

      <Section className="pt-12 pb-12 md:pt-16 md:pb-16">
        <VodafoneInteractionPatterns />
      </Section>

      <Section className="pb-12 md:pb-16">
        <VodafoneHandoff />
      </Section>

      <Section className="pb-12 md:pb-16">
        <VodafoneImpact />
      </Section>

      <Section>
        <ProjectNav prevProject={prev} nextProject={next} />
      </Section>
    </PageTransition>
  )
}
